export default __webpack_public_path__ + "static/media/212.73b6fc64.jpg";